const ubicacionInitialState = {
    ubicacion : {
        data: false, 
        loading: false, 
        error: false 
    }
}

export default ubicacionInitialState; 